import WorkspaceSidebar from './WorkspaceSidebar';
import WorkspaceSidebarSection from './WorkspaceSidebarSection';
import WorkspaceSidebarTopSection from './WorkspaceSidebarTopSection';

export default WorkspaceSidebar;

export { WorkspaceSidebar, WorkspaceSidebarSection, WorkspaceSidebarTopSection };
